
<template>
  <v-app id="onPlts">
    <v-main>
    <v-container fluid>  
    <v-card>
      
      Nr: {{plts.plts_nr}}    <v-btn class="primary ma-2" small @click="savePlts(plts)">Save</v-btn><br>
      <br>
      

      <v-text-field v-model="plts.plts_naam" label="Name"></v-text-field>

    </v-card>  
    </v-container>
    </v-main>
    <navBar title="Ares - Reference data" :home="true" type="referencedata"/>
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  props: ['plts_encrid'],
  data() {
    return {
      plts: {}
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/syst/ref/plts/getPlts.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getPlts"
          },
          getPlts: {
             plts_encrid: this.plts_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.plts = res.data.getPlts;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  methods: {
    savePlts(plts) { 
      this.$axios
        .post("ares/json/ares/syst/ref/plts/savePlts.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "savePlts"
          },
          savePlts: {
            plts: plts
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.savePlts.text,
              color: res.data.savePlts.color
            });
          }
        })
    }
  }  

};

</script> 
